export enum AIDisclosureStep {
    DISCLOSURE_INPUT = 'DISCLOSURE_INPUT',
    DISCLOSURE_RESULT = 'DISCLOSURE_RESULT',
    DEFAULT = ''
}

export enum AIDisclosureParagraphType {
    // tech_field：生成技术领域| background：生成背景技术描述 | reference：生成引用文献介绍 | drawbacks：生成现有技术的缺点 | tech_problem：生成发明目的的问题描述 | tech_effect：生成发明目的的有益效果 | tech_means：生成技术方案 | embodiment：生成实施例
    TECH_FIELD = 'tech_field',
    BACKGROUND = 'background',
    REFERENCE = 'reference',
    DRAWBACKS = 'drawbacks',
    TECH_PROBLEM = 'tech_problem',
    TECH_EFFECT = 'tech_effect',
    TECH_MEANS = 'tech_means',
    EMBODIMENT = 'embodiment'
}

export enum AIDisclosureParagraphEditType {
    // simplify：简写| expand：扩写 | polish：改写 | add_background：新增背景技术的描述 | add_reference：新增一篇引用专利 | add_drawbacks：新增一个现有技术缺点 | add_problem：新增一个问题 | add_effect：新增一个有益效果 | add_embodiment：新增一个实施例
    SIMPLIFY = 'simplify',
    EXPAND = 'expand',
    POLISH = 'polish',
    ADD_BACKGROUND = 'add_background',
    ADD_REFERENCE = 'add_reference',
    ADD_DRAWBACKS = 'add_drawbacks',
    ADD_PROBLEM = 'add_problem',
    ADD_EFFECT = 'add_effect',
    ADD_EMBODIMENT = 'add_embodiment'
}

export enum SettingLevel {
    WEEK = 'WEEK',
    MEDIUM = 'MEDIUM',
    GREAT = 'GREAT'
}

export enum StreamStatus {
    PROGRESS_WITHOUT_DATA = 'PROGRESS_WITHOUT_DATA',
    PROCESSING = 'PROCESSING',
    FINISH = 'FINISH',
    ABORTED = 'ABORTED'
}
